<template>
  <div>
    <v-container fluid>
      <v-row no-gutters>
        <v-col cols="2">
          <v-menu transition="scale-transition" offset-y v-model="dateMenu">
            <template v-slot:activator="{ on }">
              <v-text-field label="Month" hide-details dense readonly v-on="on" v-model="monthAsDate" outlined append-icon="mdi-menu-down" @click:append="dateMenu=true"/>
            </template>
            <v-date-picker v-model="month" type="month" no-title @change="refresh"/>
          </v-menu>
        </v-col>
        <v-col cols="2">
          <v-select :items="licenses" label="License" v-model="license" @change="refresh" dense hide-details outlined class="ml-6"/>
        </v-col>
        <v-col cols="1"/>
        <v-col align-self="center">
          <reports-excise-file-button :month="month"/>
        </v-col>

        <v-col class="text-right pr-2">
          <v-btn icon @click="printHtml('Excise licensed user return', report(true))"><v-icon>mdi-printer</v-icon></v-btn>
        </v-col>
      </v-row>
    </v-container>

    <v-card class="mx-4 pa-4 overflow-y" height="calc(100vh - 180px)">
      <span v-html="report(false)"/>
    </v-card>
  </div>
</template>

<script>
import {format,add} from 'date-fns'
import ReportsExciseFileButton from '@/views/reports/excise/ReportsExciseFileButton'
import printHtml from '@/mixins/printHtml'

export default {
  name: 'ReportsExciseUser',
  mixins: [printHtml],
  components: {ReportsExciseFileButton},
  data() {
    return {
      dateMenu: false,
      month: '',
      license: '',
      spiritReport: null,
      wineReport: null,
    }
  },
  computed: {
    monthAsDate() {
      return this.$formatDate(this.month+'-01', 'MMMM, yyyy');
    },
    licenses() {
      return [...new Set(this.$store.getters.sites(true, {B263:true}).map(site => site.userLicense))];
    },
  },
  async created() {
    this.$emit('name', 'Excise Duty Return - Licensed User')
    this.month = format(add(new Date(), {months:-1}), 'yyyy-MM');
    this.license = this.licenses[0];
    this.refresh();
  },
  methods: {
    number(num, precision) {
      return this.$number(num, precision);
    },
    laa(excise) {
      const entry = this.spiritReport.lines.find(line => line.excise === excise);
      return entry ? this.$number(entry.laa,3) : '0.000';
    },
    // eslint-disable-next-line no-unused-vars
    litres(excise, column) {
      const entry = this.wineReport.lines.find(line => line.excise === excise);
      return entry ? this.$number(entry[column],3) : '0.000';
    },

    async refresh() {
      if (!this.licenses.length) {
        this.$store.commit('setError', {type:'info',message:`There are no Excise Licensed User licenses`});
        return;
      }
      const results = await this.$apiCall(`query ReportsExciseUser($license:String!,$date:Date!) {
                                            exciseUserSpiritsReport(license:$license,date:$date) {
                                              openingInventory,totalAdditions,totalReductions,inventoryAdjustment,closingInventory,lines{excise,laa},
                                              header {businessName,mailingAddress,city,province,postalCode,
                                                      accountNumber,accountNumberSuffix,
                                                      periodFrom,periodTo,dueDate}
                                            }
                                            exciseUserWineReport(license:$license,date:$date) {
                                              openingInventory,totalAdditions,totalReductions,inventoryAdjustment,closingInventory,
                                              lines{excise,litres1,litres2,litres3},
                                            }
                                          }`,
                                          {license:this.license,date:this.month+'-01'});
      if (!results.error) {
        this.spiritReport = results.data.exciseUserSpiritsReport;
        this.wineReport = results.data.exciseUserWineReport;
      }
    },

    report(print) {
      if (!this.spiritReport || !this.wineReport)
        return '';

      return `<style>
                @page {size:portrait}
                .excise-report {font-family: Roboto, sans-serif; font-size:12px;width:100%;border-spacing:0;border-collapse:collapse}
                .excise-report .title {font-weight:700;font-size:18px;text-align:center}
                .excise-report .sub-title {text-align:center}
                .excise-report tbody tr {
                  height:25px;
                  padding:8px;
                  vertical-align:middle;
                }
                .spirits tbody tr:nth-child(11) td:nth-child(1) {
                  width:400px;
                }
                .spirits tbody tr:nth-child(11) td:nth-child(2) {
                  width:300px;
                }
                .spirits tbody tr:nth-child(11) td:nth-child(3) {
                  width:350px;
                }
                .spirits tbody tr:nth-child(11) td:nth-child(4) {
                  width:350px;
                }
                .spiritsDetail {
                  text-align:right;
                  padding-right:8px;
                  border:1px solid #666;
                }
                .legend {
                  font-weight:bold;
                  padding-left:5px;
                }
                .wine tbody tr:nth-child(11) td:nth-child(1) {
                  width:400px;
                }
                .wine tbody tr:nth-child(11) td:nth-child(2) {
                  width:300px;
                }
                .wine tbody tr:nth-child(11) td:nth-child(3) {
                  width:450px;
                }
                .wine tbody tr:nth-child(11) td:nth-child(4) {
                  width:450px;
                }
                .wine tbody tr:nth-child(11) td:nth-child(5) {
                  width:450px;
                }
                .wineDetail {
                  text-align:right;
                  padding-right:8px;
                  border:1px solid #666;
                }
                .page-break {
                  page-break-before: always;
                }
                .page-line {
                  border-top:thin solid #ccc;
                  margin-top: 50px;
                  margin-bottom: 50px;
                }
                </style>
                <table class="excise-report spirits">
                  <thead>
                    <tr>
                      <th colspan="5" class="title">Excise Duty Return - Licensed User</th>
                    </tr>
                    <tr>
                      <th colspan="5" class="sub-title">Account number ${this.spiritReport.header.accountNumber||''} RD ${this.spiritReport.header.accountNumberSuffix}</th>
                    </tr>
                    <tr>
                      <th colspan="5" class="sub-title">${this.spiritReport.header.periodFrom} to ${this.spiritReport.header.periodTo}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td colspan="5"/>
                    </tr>
                    <tr>
                      <td colspan="2"/>
                      <td colspan="2" style="text-align:center;font-weight:bold">Spirits</td>
                    </tr>
                    <tr>
                      <td colspan="2"/>
                      <td style="text-align:center;font-weight:bold">Containing more than 7%</td>
                      <td style="text-align:center;font-weight:bold">Containing not more than 7%</td>
                    </tr>
                    <tr>
                      <td colspan="2"/>
                      <td style="border:1px solid #666; text-align:center">Litres absolute ethyl alcohol</td>
                      <td style="border:1px solid #666; text-align:center">Litres</td>
                      <td></td>
                    </tr>
                    <tr>
                      <td/>
                      <td style="border-right;font-weight:bold; text-align:right; padding-right:8px">Opening inventory ►</td>
                      <td style="border:1px solid #000; text-align:right; padding-right:8px; border-right:none">${this.number(this.spiritReport.openingInventory,3)}</td>
                      <td style="border:1px solid #000; text-align:right; padding-right:8px; border-right:1px solid #666">0.000</td>
                      <td class="legend">A)</td>
                    </tr>

                    <tr>
                      <td colspan="4" style="border-bottom:1px solid #666; font-weight:bold">Additions to inventory</td>
                    </tr>
                    <tr>
                      <td colspan="2" style="border:1px solid #666; padding-left:8px">Domestic spirits</td>
                      <td class="spiritsDetail">${this.laa('UserSpiritsAdditionDomestic')}</td>
                      <td class="spiritsDetail">${this.litres('UserSpiritsAdditionDomestic')}</td>
                    </tr>
                    <tr>
                      <td colspan="2" style="border:1px solid #666; padding-left:8px">Imported spirits</td>
                      <td class="spiritsDetail">${this.laa('UserSpiritsAdditionImported')}</td>
                      <td class="spiritsDetail">${this.litres('UserSpiritsAdditionImported')}</td>
                    </tr>
                    <tr>
                      <td colspan="2" style="text-align:right; font-weight:bold; padding-right:8px">Total additions ►</td>
                      <td style="border:1px solid #000; text-align:right; padding-right:8px; border-right:1px solid #666">${this.number(this.spiritReport.totalAdditions,3)}</td>
                      <td style="border:1px solid #000; text-align:right; padding-right:8px; border-right:1px solid #666">0.000</td>
                      <td class="legend">B)</td>
                    </tr>

                    <tr>
                      <td colspan="4" style="border-bottom:1px solid #666; font-weight:bold">Reductions to inventory</td>
                    </tr>
                    <tr>
                      <td rowspan="2" style="border:1px solid #666; padding-left:8px">Used in an approved formulation</td>
                      <td style="border:1px solid #666; padding-left:8px">Restricted formulation</td>
                      <td class="spiritsDetail">${this.laa('UserSpiritsReductionFormulationRestricted')}</td>
                      <td class="spiritsDetail">${this.litres('UserSpiritsReductionFormulationRestricted')}</td>
                    </tr>
                    <tr>
                      <td style="border:1px solid #666; padding-left:8px">Other</td>
                      <td class="spiritsDetail">${this.laa('UserSpiritsReductionFormulationOther')}</td>
                      <td class="spiritsDetail">${this.litres('UserSpiritsReductionFormulationOther')}</td>
                    </tr>
                    <tr>
                      <td rowspan="2" style="border:1px solid #666; padding-left:8px">Used to</td>
                      <td style="border:1px solid #666; padding-left:8px">produce vinegar</td>
                      <td class="spiritsDetail">${this.laa('UserSpiritsReductionVinegar')}</td>
                      <td class="spiritsDetail">${this.litres('UserSpiritsReductionVinegar')}</td>
                    </tr>
                    <tr>
                      <td style="border:1px solid #666; padding-left:8px">fortify wine</td>
                      <td class="spiritsDetail">${this.laa('UserSpiritsReductionFortifyWine')}</td>
                      <td class="spiritsDetail">${this.litres('UserSpiritsReductionFortifyWine')}</td>
                    </tr>
                    <tr>
                      <td colspan="2" style="border:1px solid #666; padding-left:8px">Returned to spirits licensee or excise warehouse licensee</td>
                      <td class="spiritsDetail">${this.laa('UserSpiritsReductionReturnedToLicensee')}</td>
                      <td class="spiritsDetail">${this.litres('UserSpiritsReductionReturnedToLicensee')}</td>
                    </tr>
                    <tr>
                      <td colspan="2" style="border:1px solid #666; padding-left:8px">Exported spirits</td>
                      <td class="spiritsDetail">${this.laa('UserSpiritsReductionExported')}</td>
                      <td class="spiritsDetail">${this.litres('UserSpiritsReductionExported')}</td>
                    </tr>
                    <tr>
                      <td colspan="2" style="border:1px solid #666; padding-left:8px">Used in approved processes</td>
                      <td class="spiritsDetail">${this.laa('UserSpiritsReductionApprovedProcess')}</td>
                      <td class="spiritsDetail">${this.litres('UserSpiritsReductionApprovedProcess')}</td>
                    </tr>
                    <tr>
                      <td colspan="2" style="border:1px solid #666; padding-left:8px">Removed for other purposes (specify)</td>
                      <td class="spiritsDetail">${this.laa('UserSpiritsReductionOtherPurpose')}</td>
                      <td class="spiritsDetail">${this.litres('UserSpiritsReductionOtherPurpose')}</td>
                    </tr>
                    <tr>
                      <td colspan="2" style="text-align:right; font-weight:bold; padding-right:8px">Total reductions ►</td>
                      <td style="border:1px solid #000; text-align:right; padding-right:8px; border-right:1px solid #666">${this.number(this.spiritReport.totalReductions,3)}</td>
                      <td style="border:1px solid #000; text-align:right; padding-right:8px; border-right:1px solid #666">0.000</td>
                      <td class="legend">C)</td>
                    </tr>

                    <tr>
                      <td colspan="5"></td>
                    </tr>
                    <tr>
                      <td colspan="2" style="text-align:right; font-weight:bold; padding-right:8px">Inventory adjustments (+ or – ) ►</td>
                      <td style="border:1px solid #000; text-align:right; padding-right:8px; border-right:1px solid #666">${this.number(this.spiritReport.inventoryAdjustment,3)}</td>
                      <td style="border:1px solid #000; text-align:right; padding-right:8px; border-right:1px solid #666">0.000</td>
                      <td class="legend">D)</td>
                    </tr>
                    <tr>
                      <td colspan="5"></td>
                    </tr>
                    <tr>
                      <td colspan="2" style="text-align:right; font-weight:bold; padding-right:8px">Closing inventory (A +B) – C ± D ►</td>
                      <td style="border:1px solid #000; text-align:right; padding-right:8px; border-right:1px solid #666">${this.number(this.spiritReport.closingInventory,3)}</td>
                      <td style="border:1px solid #000; text-align:right; padding-right:8px; border-right:1px solid #666">0.000</td>
                      <td class="legend">E)</td>
                    </tr>
                  </tbody>
                </table>

                <div class="${print?'page-break':'page-line'}"></div>

                <table class="excise-report wine">
                  <thead>
                    <tr>
                      <th colspan="6" class="title">Excise Duty Return - Licensed User</th>
                    </tr>
                    <tr>
                      <th colspan="6" class="sub-title">Account number ${this.spiritReport.header.accountNumber||''} RD ${this.spiritReport.header.accountNumberSuffix}</th>
                    </tr>
                    <tr>
                      <th colspan="6" class="sub-title">${this.spiritReport.header.periodFrom} to ${this.spiritReport.header.periodTo}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td colspan="6"/>
                    </tr>
                    <tr>
                      <td colspan="2"/>
                      <td colspan="3" style="text-align:center;font-weight:bold">Wine</td>
                      <td></td>
                    </tr>
                    <tr>
                      <td colspan="2"/>
                      <td style="text-align:center;font-weight:bold">Containing more than 7%</td>
                      <td style="text-align:center;font-weight:bold">Containing more than 1.2%, but not more than 7%</td>
                      <td style="text-align:center;font-weight:bold">Containing not more than 1.2%</td>
                      <td></td>
                    </tr>
                    <tr>
                      <td colspan="2"/>
                      <td style="border:1px solid #666; text-align:center">Litres</td>
                      <td style="border:1px solid #666; text-align:center">Litres</td>
                      <td style="border:1px solid #666; text-align:center">Litres</td>
                      <td></td>
                    </tr>
                    <tr>
                      <td colspan="2" style="border-right;font-weight:bold; text-align:right; padding-right:8px">Opening inventory ►</td>
                      <td style="border:1px solid #000; text-align:right; padding-right:8px; border-right:none">${this.number(this.wineReport.openingInventory[0],3)}</td>
                      <td style="border:1px solid #000; text-align:right; padding-right:8px; border-right:none">${this.number(this.wineReport.openingInventory[1],3)}</td>
                      <td style="border:1px solid #000; text-align:right; padding-right:8px; border-right:1px solid #666">${this.number(this.wineReport.openingInventory[2],3)}</td>
                      <td class="legend">A)</td>
                    </tr>

                    <tr>
                      <td colspan="5" style="font-weight:bold">Additions to inventory</td>
                    </tr>

                    <tr>
                      <td colspan="2" style="border:1px solid #666; padding-left:8px">Domestic wine</td>
                      <td class="wineDetail">${this.litres('UserWineAdditionDomestic','litres1')}</td>
                      <td class="wineDetail">${this.litres('UserWineAdditionDomestic','litres2')}</td>
                      <td class="wineDetail">${this.litres('UserWineAdditionDomestic','litres3')}</td>
                      <td></td>
                    </tr>
                    <tr>
                      <td colspan="2" style="border:1px solid #666; padding-left:8px">Imported wine</td>
                      <td class="wineDetail">${this.litres('UserWineAdditionImported','litres1')}</td>
                      <td class="wineDetail">${this.litres('UserWineAdditionImported','litres2')}</td>
                      <td class="wineDetail">${this.litres('UserWineAdditionImported','litres3')}</td>
                      <td></td>
                    </tr>
                    <tr>
                      <td colspan="2" style="text-align:right; font-weight:bold; padding-right:8px">Total additions ►</td>
                      <td style="border:1px solid #000; text-align:right; padding-right:8px; border-right:1px solid #666">${this.number(this.wineReport.totalAdditions[0],3)}</td>
                      <td style="border:1px solid #000; text-align:right; padding-right:8px; border-right:1px solid #666">${this.number(this.wineReport.totalAdditions[1],3)}</td>
                      <td style="border:1px solid #000; text-align:right; padding-right:8px; border-right:1px solid #666">${this.number(this.wineReport.totalAdditions[2],3)}</td>
                      <td class="legend">B)</td>
                    </tr>

                    <tr>
                      <td colspan="5" style="border-bottom:1px solid #666; font-weight:bold">Reductions to inventory</td>
                    </tr>
                    <tr>
                      <td rowspan="2" style="border:1px solid #666; padding-left:8px">Used in an approved formulation</td>
                      <td style="border:1px solid #666; padding-left:8px">Restricted formulation</td>
                      <td class="wineDetail">${this.litres('UserWineReductionFormulationRestricted','litres1')}</td>
                      <td class="wineDetail">${this.litres('UserWineReductionFormulationRestricted','litres2')}</td>
                      <td class="wineDetail">${this.litres('UserWineReductionFormulationRestricted','litres3')}</td>
                      <td></td>
                    </tr>
                    <tr>
                      <td style="border:1px solid #666; padding-left:8px">Other</td>
                      <td class="wineDetail">${this.litres('UserWineReductionFormulationOther','litres1')}</td>
                      <td class="wineDetail">${this.litres('UserWineReductionFormulationOther','litres2')}</td>
                      <td class="wineDetail">${this.litres('UserWineReductionFormulationOther','litres3')}</td>
                      <td></td>
                    </tr>
                    <tr>
                      <td colspan="2" style="border:1px solid #666; padding-left:8px">Used to produce vinegar</td>
                      <td class="wineDetail">${this.litres('UserWineReductionVinegar','litres1')}</td>
                      <td class="wineDetail">${this.litres('UserWineReductionVinegar','litres2')}</td>
                      <td class="wineDetail">${this.litres('UserWineReductionVinegar','litres3')}</td>
                      <td></td>
                    </tr>
                    <tr>
                      <td colspan="2" style="border:1px solid #666; padding-left:8px">Blended with spirits to produce spirits</td>
                      <td class="wineDetail">${this.litres('UserWineReductionBlendedWithSpirits','litres1')}</td>
                      <td class="wineDetail">${this.litres('UserWineReductionBlendedWithSpirits','litres2')}</td>
                      <td class="wineDetail">${this.litres('UserWineReductionBlendedWithSpirits','litres3')}</td>
                      <td></td>
                    </tr>
                    <tr>
                      <td colspan="2" style="border:1px solid #666; padding-left:8px">Returned to wine licensee or excise warehouse licensee</td>
                      <td class="wineDetail">${this.litres('UserWineReductionReturnedToLicensee','litres1')}</td>
                      <td class="wineDetail">${this.litres('UserWineReductionReturnedToLicensee','litres2')}</td>
                      <td class="wineDetail">${this.litres('UserWineReductionReturnedToLicensee','litres3')}</td>
                      <td></td>
                    </tr>
                    <tr>
                      <td colspan="2" style="border:1px solid #666; padding-left:8px">Exported wine</td>
                      <td class="wineDetail">${this.litres('UserWineReductionExported','litres1')}</td>
                      <td class="wineDetail">${this.litres('UserWineReductionExported','litres2')}</td>
                      <td class="wineDetail">${this.litres('UserWineReductionExported','litres3')}</td>
                      <td></td>
                    </tr>
                    <tr>
                      <td colspan="2" style="border:1px solid #666; padding-left:8px">Used in approved processes</td>
                      <td class="wineDetail">${this.litres('UserWineReductionApprovedProcess','litres1')}</td>
                      <td class="wineDetail">${this.litres('UserWineReductionApprovedProcess','litres2')}</td>
                      <td class="wineDetail">${this.litres('UserWineReductionApprovedProcess','litres3')}</td>
                      <td></td>
                    </tr>
                    <tr>
                      <td colspan="2" style="border:1px solid #666; padding-left:8px">Removed for other purposes (specify)</td>
                      <td class="wineDetail">${this.litres('UserWineReductionOther','litres1')}</td>
                      <td class="wineDetail">${this.litres('UserWineReductionOther','litres2')}</td>
                      <td class="wineDetail">${this.litres('UserWineReductionOther','litres3')}</td>
                      <td></td>
                    </tr>
                    <tr>
                      <td colspan="2" style="text-align:right; font-weight:bold; padding-right:8px">Total reductions ►</td>
                      <td style="border:1px solid #000; text-align:right; padding-right:8px; border-right:1px solid #666">${this.number(this.wineReport.totalReductions[0],3)}</td>
                      <td style="border:1px solid #000; text-align:right; padding-right:8px; border-right:1px solid #666">${this.number(this.wineReport.totalReductions[1],3)}</td>
                      <td style="border:1px solid #000; text-align:right; padding-right:8px; border-right:1px solid #666">${this.number(this.wineReport.totalReductions[2],3)}</td>
                      <td class="legend">C)</td>
                    </tr>

                    <tr>
                      <td colspan="6"></td>
                    </tr>

                    <tr>
                      <td colspan="2" style="text-align:right; font-weight:bold; padding-right:8px">Inventory adjustments (+ or – ) ►</td>
                      <td style="border:1px solid #000; text-align:right; padding-right:8px; border-right:1px solid #666">${this.litres('UserWineInventoryAdjustment','litres1')}</td>
                      <td style="border:1px solid #000; text-align:right; padding-right:8px; border-right:1px solid #666">${this.litres('UserWineInventoryAdjustment','litres2')}</td>
                      <td style="border:1px solid #000; text-align:right; padding-right:8px; border-right:1px solid #666">${this.litres('UserWineInventoryAdjustment','litres3')}</td>
                      <td class="legend">D)</td>
                    </tr>
                    <tr>
                      <td colspan="6"></td>
                    </tr>
                    <tr>
                      <td colspan="2" style="text-align:right; font-weight:bold; padding-right:8px">Closing inventory (A +B) – C ± D ►</td>
                      <td style="border:1px solid #000; text-align:right; padding-right:8px; border-right:1px solid #666">${this.number(this.wineReport.closingInventory[0],3)}</td>
                      <td style="border:1px solid #000; text-align:right; padding-right:8px; border-right:1px solid #666">${this.number(this.wineReport.closingInventory[1],3)}</td>
                      <td style="border:1px solid #000; text-align:right; padding-right:8px; border-right:1px solid #666">${this.number(this.wineReport.closingInventory[2],3)}</td>
                      <td class="legend">E)</td>
                    </tr>
                  </tbody>
                </table>`;
    }
  }
}
</script>